"use client";

import { X } from "lucide-react";

interface VehicleSearchInputsProps {
  make: string;
  setMake: (v: string) => void;
  model: string;
  setModel: (v: string) => void;
  year: string;
  setYear: (v: string) => void;
  onClear: (v: string) => void;
}

export function VehicleSearchInputs({
  make,
  setMake,
  model,
  setModel,
  year,
  setYear,
  onClear,
}: VehicleSearchInputsProps) {
  return (
    <div className="vehicle-input-row ">

      <div className="autocomplete-with-clear">
        <input
          placeholder="Make"
          value={make}
          onChange={(e) => setMake(e.target.value)}
          className="vehicle-input standard-input"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Escape") {
              e.currentTarget.blur(); 
            }
          }}
        />
        <button
          onClick={() => onClear("make")}
          className="close-btn clear-icon"
          tabIndex={-1}
          aria-label="Clear input"
        >
          <X className="sortable-clear-btn"/>
        </button>
      </div>

      <div className="autocomplete-with-clear">
        <input
          placeholder="Model"
          value={model}
          onChange={(e) => setModel(e.target.value)}
          className="vehicle-input standard-input"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Escape") {
              e.currentTarget.blur(); 
            }
          }}
        />
        <button
          onClick={() => onClear("model")}
          className="close-btn clear-icon"
          tabIndex={-1}
          aria-label="Clear input"
        >
          <X className="sortable-clear-btn"/>
        </button>
      </div>

      <div className="autocomplete-with-clear">
        <input
          placeholder="Year"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          className="vehicle-input standard-input"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Escape") {
              e.currentTarget.blur(); 
            }
          }}
        />
        <button
          onClick={() => onClear("year")}
          className="close-btn clear-icon"
          tabIndex={-1}
          aria-label="Clear input"
        >
          <X className="sortable-clear-btn"/>
        </button>
      </div>

    </div>
  );
}
